<template>
  <div>
    <generic-container :title="$t('active support plans')" icon="file contract">aaa</generic-container>
  </div>
</template>

<script>
import { local_api, normalize_error } from "@/utils";
import filters from "@/filters";
import GenericContainer from "@/components/GenericContainer";

// @ is an alias to /src
export default {
  name: "SupportControlExternalView",
  components: {
    "generic-container": GenericContainer
  },
  filters: filters,
  data() {
    return {};
  },
  methods: {},
  created() {
    let vm = this;
    let service_uuid = this.$route.query.i;
    let context = this.$route.query.c;
    local_api(vm, "post", "/support_control/external/do-get", {
      i: service_uuid,
      c: context
    })
      .then(data => {
        console.log(data);
      })
      .catch(err => {
        normalize_error(vm, err);
      });
  },
  mounted() {},
  watch: {}
};
</script>
